
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const DECREASE_NOTIFICATION = "DECREASE_NOTIFICATION";
export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_SNACKBAR = "SET_SNACKBAR";
export const CLEAR_SNACKBAR = "CLEAR_SNACKBAR";